module.exports = __webpack_public_path__ + "img/phoneImg.f493c4ae.jpg";